import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

/**
 * Catering — info page promoting Tía Sandra's catering for parties,
 * corporate events, and gatherings of any size.
 *
 * There is intentionally no online catering order form: Sandra prefers
 * to talk through guest counts, menu, and timing on the phone so each
 * event gets food made fresh to order. The page therefore funnels
 * visitors to a single phone CTA.
 */
function Catering() {
  const { t } = useTranslation()

  return (
    <section className="section order-coming-soon" aria-labelledby="catering-heading">
      <div className="container">
        <h1 id="catering-heading">{t('catering.heading')}</h1>
        <p className="order-body">{t('catering.body')}</p>
        <p className="order-body">{t('catering.freshLine')}</p>
        <p className="order-body">{t('catering.callPrompt')}</p>

        <div className="hero-cta-row">
          <a href="tel:+14694917604" className="btn-primary">
            {t('catering.callCta')}
          </a>
        </div>

        <p className="order-back">
          <Link to="/" className="order-coming-soon-back">
            ← {t('catering.backHome')}
          </Link>
        </p>
      </div>
    </section>
  )
}

export default Catering
